import React, { useState } from "react";
import "./AdjustmentTools.scss";
import { CloseIcon, CrossCircleIcon, ExpandIcon, MoveIcon } from "../../../assets/Svg/SvgImages.jsx";
const AdjustmentTools = props => {
  const {
    name,
    onClose,
    onExtend,
    onReduce
  } = props;
  const [extend, setExtend] = useState(false);
  const handleOnClose = () => {
    onClose(name);
  };
  const handleOnExtend = () => {
    onExtend(name);
    // setExtend(true);
  };
  const handleOnReduce = () => {
    onReduce(name);
    setExtend(false);
  };
  return <>
      <div className="cardHeader">
        <ul className="card_adjustment_btn nondraggable_card">
          <li>
            <button onClick={() => {
            if (extend) {
              handleOnReduce();
            } else {
              handleOnExtend();
            }
          }} className="zoom_view">
              {extend ? <ExpandIcon /> : <ExpandIcon />}
            </button>
          </li>
          {extend ? "" : <li>
              <button onClick={handleOnClose}>
                <CloseIcon />
              </button>
            </li>}
        </ul>
        <div className="cardMove drag-handle">
          <MoveIcon />
        </div>
      </div>
    </>;
};
export default AdjustmentTools;